import { AlertTriangle } from 'lucide-react';

interface Props {
  mensagem: string;
  retryAfterSegundos?: number | undefined;
}

/** Minutos arredondados para cima — "tente em 47 segundos" não ajuda ninguém
 * a decidir quando voltar; "tente em 1 minuto" ajuda. */
function emMinutos(segundos: number): string {
  const minutos = Math.max(1, Math.ceil(segundos / 60));
  return minutos === 1 ? '1 minuto' : `${minutos} minutos`;
}

/**
 * Mensagem de erro da auditoria pública. A frase em si já vem pronta da API
 * (`ErroDominio.message`, ver `apps/api/src/auditoria/*`) — em português e
 * dizendo o que fazer; aqui só se acrescenta o `Retry-After` quando existe
 * (`limite_ip`, `sobrecarga`), formatado para gente, não para máquina.
 */
export function ErroAuditoriaAviso({ mensagem, retryAfterSegundos }: Props): JSX.Element {
  return (
    <div
      role="alert"
      className="border-auth-erro/30 bg-auth-erro/10 rounded-auth-card flex items-start gap-3 border p-4"
    >
      <AlertTriangle size={18} className="text-auth-erro mt-0.5 shrink-0" aria-hidden />
      <p className="text-auth-texto text-sm leading-relaxed">
        {mensagem}
        {retryAfterSegundos ? (
          <span className="text-auth-texto-secundario">
            {' '}
            Tente novamente em {emMinutos(retryAfterSegundos)}.
          </span>
        ) : null}
      </p>
    </div>
  );
}
